import z from 'zod';

import { ApiVolcanoIdZod } from './ApiVolcano';

export const GetVolcanoIdsResponseZod = z.object({
  volcanoes: z.array(ApiVolcanoIdZod),
});
